<div class="page-wrapper">
  <div class="option-card">
    <div class="option-card-header">
      <span class="fas fa-file-alt"></span>
      {{ 'LEGAL.TITLE.CANCELLATION-POLICY' | translate }}
    </div>
    <div class="option-card-body">
      @switch (((brandingData$ | async)?.legalCancellationPolicy)) {
        @case ('agaplesion-CP') {
          <app-cancellation-policy-agaplesion></app-cancellation-policy-agaplesion>
        }
        @default {
          <app-cancellation-policy-patientus></app-cancellation-policy-patientus>
        }
      }
    </div>
  </div>
</div>
